import { CardNumberElement } from "@stripe/react-stripe-js";
import { getCsrfCookieName } from "helpers/gazetteGetCsrfCookieName";
import { getCookie } from "helpers/gazetteGetCookie";
import { getValidationError } from "core/Form/helpers";

export const processTransaction = async (
    form,
    body,
    routeURL,
    stripe,
    elements
) => {
    let formError;
    let success = false;

    const cardNumberElement = elements.getElement(CardNumberElement);
    const { token, error } = await stripe.createToken(cardNumberElement, form);

    const csrfCookieName = getCsrfCookieName();
    const csrftoken = getCookie({ name: csrfCookieName });

    if (error) {
        return {
            formError: error.message,
            success
        };
    }

    body.stripe_token = token.id;

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrftoken
        },
        body: JSON.stringify(body)
    };

    const response = await fetch(routeURL, options);
    const payload = await response.json();

    if (!payload) {
        formError = "Something went wrong.";
    } else if (payload.errors || payload.error) {
        formError = getFinalPurchaseError(
            payload.error || payload.errors.error
        );
    } else {
        formError = false;
        success = true;
    }

    return {
        formError,
        success
    };

    function getFinalPurchaseError(errorObject) {
        if (!errorObject) return;

        if (errorObject.code === "card_declined") {
            return "Your card was declined.";
        } else {
            return errorObject.message;
        }
    }
};

const minChars = charMin => string => string.trim().length >= charMin;
const maxChars = charMax => string => string.trim().length <= charMax;
const validEmail = input => /.+@.+\..+/.test(input);

export const roleFieldValidation = [
    {
        isValid: minChars(1),
        errorMsg: "Please enter your role in education."
    },
    {
        isValid: maxChars(255),
        errorMsg: "Must not exceed 255 characters."
    }
];

export const schoolFieldValidation = [
    {
        isValid: minChars(1),
        errorMsg: "Please enter your school name."
    },
    {
        isValid: maxChars(255),
        errorMsg: "Must not exceed 255 characters."
    }
];

export const emailFieldValidation = [
    {
        isValid: minChars(1),
        errorMsg: "Please add your email address."
    },
    {
        isValid: maxChars(254),
        errorMsg: "Must not exceed 254 characters."
    },
    {
        isValid: validEmail,
        errorMsg: "Please enter a valid email address."
    }
];

export const howUseIconsFieldValidation = [
    {
        isValid: maxChars(255),
        errorMsg: "Must not exceed 255 characters."
    }
];

// EDU application validation checks
export const checkForErrors = ({
    applicantRole,
    schoolName,
    iconUsage,
    emailAddr
}) => {
    const isRoleErr = getValidationError({
        input: applicantRole,
        validation: roleFieldValidation
    });

    const isSchoolErr = getValidationError({
        input: schoolName,
        validation: schoolFieldValidation
    });

    const isIconsErr = getValidationError({
        input: iconUsage,
        validation: howUseIconsFieldValidation
    });

    const isEmailErr = getValidationError({
        input: emailAddr,
        validation: emailFieldValidation
    });

    if (isRoleErr) {
        return isRoleErr;
    } else if (isSchoolErr) {
        return isSchoolErr;
    } else if (isIconsErr) {
        return isIconsErr;
    } else if (isEmailErr) {
        return isEmailErr;
    } else {
        return "";
    }
};
